import React from 'react';

const SectionTitle = ({ children }) => {
  return <h3 className="section-title">{children}</h3>;
};

export default SectionTitle;